module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "233",
      "src": "images/14.jpg",
      "width": "350"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whether it’s a dorm room, apartment, or house, getting your own place goes beyond having a place to sleep—it’s establishing your own home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before getting a place, consider what you want to use your home for. Do you just need space for a bed, or do you need enough room to entertain family and friends?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Think about what you want your first home to be. Safe? Friendly? Clean? Convenient? Comfortable? Charming? Exciting? Affordable? Spacious? Practical? Extravagant?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consider your housing priorities, then use this section to help you find the right place for you.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5e9a79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part03.vue
// module id = 114
// module chunks = 0